import script from "./commentItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./commentItem.vue?vue&type=script&lang=ts&setup=true"

import "./commentItem.vue?vue&type=style&index=0&id=315c62bf&scoped=true&lang=scss"

import exportComponent from "/Users/zhangjun/Desktop/project/envo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-315c62bf"]])

export default __exports__